document.addEventListener('DOMContentLoaded', function () {
  let miniCartButton = document.querySelector('[aria-controls="mini-cart"]') 
  if (miniCartButton) {
    miniCartButton.addEventListener('click', ()=>{
      if (typeof BSS_B2B == 'object' ) {
        setTimeout(()=>{
          BSS_B2B.observer.cartSubject.listenCartCheckout()
        },500)
      }
    })
  }
});